import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'

import CookieConsent from '../components/CookieConsent'
import Navigation from '../components/Navigation'
import ContentBlock from '../components/ContentBlock'
import ContactForm from '../components/ContactForm'
import Icon from '../components/Icon'
import Footer from '../components/Footer'
import CTA from '../components/CTA'

import { cookies } from '../utils'
import localization from '../localization/common'

import img_ogImage from '../assets/shared/ogImage.jpg'

import img_contactInfoBackground from '../assets/shared/contactInfoBackground.jpg'
import img_contactFormBackground from '../assets/shared/contactFormBackground.jpg'

import styles from './index.module.styl'

import '../styles/style.styl'

class TemplateWrapper extends Component {
  static propTypes = {
    children: PropTypes.func,
  }

  state = {
    language: 'en',
    loading: true
  }

  componentDidMount = () => {
    this._setLanguage()
    this.setState({ loading: false })
  }

  _setLanguage = (language) => {
    // Add 10 years to current date
    const date = new Date()
    date.setFullYear(date.getFullYear() + 10)

    if (!language) {
      const langPref = cookies.get('LOCALE')

      if (langPref) {
        this.setState({ language: langPref })
      } else {
        const hostname = window.location.href.split('/')[2]
        const splitHref = hostname.split('.')
        const domainExt = splitHref[splitHref.length - 1]

        switch (domainExt) {
          case 'nl':
            this.setState({ language: 'nl' })
            cookies.set('LOCALE', 'nl', { path: '/', expires: date })
            break

          case 'de':
            this.setState({ language: 'de' })
            cookies.set('LOCALE', 'de', { path: '/', expires: date })
            break

          default:
            this.setState({ language: 'en' })
            cookies.set('LOCALE', 'en', { path: '/', expires: date })
            break
        }
      }
    } else {
      this.setState({ language })
      cookies.set('LOCALE', language, { path: '/', expires: date })
    }

    return true
  }

  render() {
    const { language } = this.state

    if (this.state.loading) {
      return (
        <React.Fragment>
          <Helmet
            title="Ferienhaus Vulkaneifel Kopp"
            meta={[
              { name: 'description', content: localization[language].metaDescription },
              { name: 'keywords', content: localization[language].metaKeywords },
              { property: 'og:title', content: 'Ferienhaus Vulkaneifel Kopp' },
              { property: 'og:description', content: localization[language].metaDescription },
              { property: 'og:image', content: `https://www.ferienhaus-vek.de${img_ogImage}` },
              { property: 'og:image:width', content: '1200' },
              { property: 'og:image:height', content: '1200' }
            ]}
          />

          <div className="loader" />
        </React.Fragment>
      )
    }

    return (
      <React.Fragment>
        <Helmet
          title="Ferienhaus Vulkaneifel Kopp"
          meta={[
            { name: 'description', content: localization[language].metaDescription },
            { name: 'keywords', content: localization[language].metaKeywords },
            { property: 'og:title', content: 'Ferienhaus Vulkaneifel Kopp' },
            { property: 'og:description', content: localization[language].metaDescription },
            { property: 'og:image', content: `https://www.ferienhaus-vek.de${img_ogImage}` },
            { property: 'og:image:width', content: '1200' },
            { property: 'og:image:height', content: '1200' }
          ]}
        />

        <CookieConsent cookies={cookies} language={language} />

        <div className={styles.wrapper}>
          <Navigation language={language} setLanguage={this._setLanguage} />

          {this.props.children({ ...this.props, language })}

          <ContentBlock split antiReverse darkBackgroundLeft>
            <div style={{ backgroundImage: `url(${img_contactInfoBackground})` }}>
              <h2 className="t-heading-s">{localization[language].contactInfoTitle}</h2>
              <div className={styles.contactInfoBlock}>
                <Icon type="mappin" size={24} />
                <p>
                  Ferienhaus Vulkaneifel Kopp<br />
                  Dorfstraße 1<br />
                  54574 Kopp<br />
                  {localization[language].germany}
                </p>
              </div>

              <div className={styles.contactInfoBlock}>
                <Icon type="phone" size={24} />
                <p>
                  +31 (0)6 10 18 64 78
                </p>
              </div>
            </div>
            <div style={{ backgroundImage: `url(${img_contactFormBackground})` }}>
              <h2 className="t-heading-s">{localization[language].contactFormTitle}</h2>
              <ContactForm language={this.state.language} />
            </div>
          </ContentBlock>

          <CTA language={this.state.language} />

          <Footer language={this.state.language} />
        </div>
      </React.Fragment>
    )
  }
}

export default TemplateWrapper




// WEBPACK FOOTER //
// ./src/layouts/index.js